import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';

export function get_files_from_clipboard(event: ClipboardEvent) {
  const items = Array.from(event.clipboardData?.items || []);
  if (!items) return [];
  if (items.is_empty()) return [];

  let out = [];

  for (let item of items) {
    if (!item.type.startsWith('image')) continue;

    const file = item.getAsFile();
    if (!file) continue;

    out.push(file);
  }

  return out;
}

export function path_relative_to_absolute(url_relative: string): string {
  let out = url_relative.trim() ? new URL(url_relative.trim(), CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_URL).toString() : '';

  return out;
}

export async function file_to_blob(file: File): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        const out = new Uint8Array(reader.result);
        resolve(out);
      } else {
        reject(new Error('Failed to read file as an ArrayBuffer'));
      }
    };

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
  });
}

export function blob_to_file(blob: Uint8Array, filename: string, mimetype: string): File {
  return new File([blob], filename, { type: mimetype });
}
